(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aco-paint-chip"] && !Shopify.designMode) return;
  try {
    (() => {
  const clamp = (x, a = 0, b = 1) => Math.max(a, Math.min(b, x));
  const unit = v => { const l = Math.hypot(...v) || 1; return v.map(x => x / l); };
  const mix = (a, b, t) => [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t];
  // Exact sRGB transfer so the chip face reproduces the catalog swatch hex.
  const toLinear = c => c <= .04045 ? c / 12.92 : Math.pow((c + .055) / 1.055, 2.4);
  const color = value => /^#[0-9a-f]{6}$/i.test(value || '') ? [1, 3, 5].map(i => toLinear(parseInt(value.slice(i, i + 2), 16) / 255)) : [.2, .2, .2];
  const encode = Uint8Array.from({length: 8192}, (_, i) => { const c = i / 8191; return Math.round(255 * (c <= .0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - .055)); });
  const decode = Float32Array.from({length: 256}, (_, i) => toLinear(i / 255));
  const toByte = x => encode[x <= 0 ? 0 : x >= 1 ? 8191 : (x * 8191) | 0];
  // Soft highlight shoulder: colours below 0.85 (linear) are untouched, brighter values roll off instead of clipping.
  const shoulder = x => x < .85 ? x : .85 + .15 * (1 - Math.exp((.85 - x) / .15));

  // OKLab (perceptual) helpers for metallic travel and pearl colour shift.
  const toOklab = ([r, g, b]) => {
    const l = Math.cbrt(.4122214708 * r + .5363325363 * g + .0514459929 * b), m = Math.cbrt(.2119034982 * r + .6806995451 * g + .1073969566 * b), s = Math.cbrt(.0883024619 * r + .2817188376 * g + .6299787005 * b);
    return [.2104542553 * l + .793617785 * m - .0040720468 * s, 1.9779984951 * l - 2.428592205 * m + .4505937099 * s, .0259040371 * l + .7827717662 * m - .808675766 * s];
  };
  const fromOklab = ([L, a, b]) => {
    const l = (L + .3963377774 * a + .2158037573 * b) ** 3, m = (L - .1055613458 * a - .0638541728 * b) ** 3, s = (L - .0894841775 * a - 1.291485548 * b) ** 3;
    return [4.0767416621 * l - 3.3077115913 * m + .2309699292 * s, -1.2684380046 * l + 2.6097574011 * m - .3413193965 * s, -.0041960863 * l - .7034186147 * m + 1.707614701 * s].map(x => clamp(x));
  };
  const lch = (L, C, h) => fromOklab([clamp(L), C * Math.cos(h), C * Math.sin(h)]);

  // Finish tones. Everything is anchored to the swatch photo: the face colour is the photo's median, and the
  // highlight / flop hues come from the photo's own brightest and darkest areas, so nothing is invented.
  function finishPalette(base, photo) {
    const [L, a, b] = toOklab(base), C = Math.hypot(a, b), h = Math.atan2(b, a);
    const metalHigh = lch(L + .15 * (1 - L) + .03, C * .9, h);
    const metalFlop = lch(L * .75, C * 1.04, h);
    const metalSpark = mix(lch(Math.max(L, .8), C * .5, h), [1, 1, 1], .4);
    const bright = photo?.bright ? toOklab(photo.bright) : [L, a, b], dark = photo?.dark ? toOklab(photo.dark) : [L, a, b];
    const hueOf = v => Math.atan2(v[2], v[1]), chromaOf = v => Math.hypot(v[1], v[2]);
    const pearlSheen = lch(L + .08, chromaOf(bright), hueOf(bright));
    const pearlFlop = lch(L * .8, chromaOf(dark), hueOf(dark));
    const pearlSpark = lch(Math.max(.82, L + .2), chromaOf(bright) * .8, hueOf(bright));
    return {metalHigh, metalFlop, metalSpark, pearlSheen, pearlFlop, pearlSpark};
  }

  // Reads the product's main swatch photo:
  //  - face colour: median of the central 50% (same method used for the catalog swatch values);
  //  - flake: fine-grain texture in the photo (robust spread of a high-pass filter), above the compression-noise floor;
  //  - pearl: hue difference between the photo's brightest and darkest areas.
  // A flat photo gives no flake and no pearl, so the chip stays a clean gloss finish.
  function analyzeSwatch(src) {
    return new Promise((resolve, reject) => {
      if (!src) return reject(new Error('no swatch'));
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => {
        try {
          const w = Math.max(8, Math.min(600, image.naturalWidth)), h = Math.max(8, Math.round(w * image.naturalHeight / Math.max(1, image.naturalWidth)));
          const canvas = document.createElement('canvas'); canvas.width = w; canvas.height = h;
          const context = canvas.getContext('2d', {willReadFrequently: true}); context.drawImage(image, 0, 0, w, h);
          const data = context.getImageData(0, 0, w, h).data;
          const x0 = Math.floor(w * .25), x1 = Math.ceil(w * .75), y0 = Math.floor(h * .25), y1 = Math.ceil(h * .75);
          const median = list => { list.sort((p, q) => p - q); const m = list.length >> 1; return list.length % 2 ? list[m] : (list[m - 1] + list[m]) / 2; };
          const channels = [[], [], []], luma = new Float32Array(w * h);
          for (let i = 0; i < w * h; i++) luma[i] = .2126 * data[i * 4] + .7152 * data[i * 4 + 1] + .0722 * data[i * 4 + 2];
          for (let y = y0; y < y1; y++) for (let x = x0; x < x1; x++) { const i = (y * w + x) * 4; if (data[i + 3] > 200) for (let k = 0; k < 3; k++) channels[k].push(data[i + k]); }
          if (!channels[0].length) return reject(new Error('empty swatch'));
          const face = '#' + channels.map(list => Math.round(median(list)).toString(16).padStart(2, '0')).join('');
          // Fine grain: deviation from the 3x3 neighbourhood mean, robust (median absolute deviation).
          const rx0 = Math.max(1, x0), rx1 = Math.min(w - 1, x1), ry0 = Math.max(1, y0), ry1 = Math.min(h - 1, y1);
          const residual = new Float32Array(Math.max(1, (rx1 - rx0) * (ry1 - ry0)));
          let count = 0;
          for (let y = ry0; y < ry1; y++) for (let x = rx0; x < rx1; x++) {
            let sum = 0; for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) sum += luma[(y + dy) * w + x + dx];
            residual[count++] = Math.abs(luma[y * w + x] - sum / 9);
          }
          // Typed-array sort is numeric and several times faster than sorting a plain array on phones.
          const sorted = residual.subarray(0, Math.max(1, count)).sort(), mid = sorted.length >> 1;
          const grain = 1.4826 * (sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2) * 1.125;
          // Broad tones: average 8x8 blocks, then compare the brightest and darkest 15% of blocks.
          const blocks = [];
          for (let by = 0; by + 8 <= h; by += 8) for (let bx = 0; bx + 8 <= w; bx += 8) {
            let r = 0, g = 0, b = 0;
            for (let y = by; y < by + 8; y++) for (let x = bx; x < bx + 8; x++) { const i = (y * w + x) * 4; r += decode[data[i]]; g += decode[data[i + 1]]; b += decode[data[i + 2]]; }
            const rgb = [r / 64, g / 64, b / 64]; blocks.push({rgb, lab: toOklab(rgb)});
          }
          blocks.sort((p, q) => p.lab[0] - q.lab[0]);
          const take = Math.max(1, Math.round(blocks.length * .15)), avg = list => [0, 1, 2].map(k => list.reduce((t, item) => t + item.rgb[k], 0) / list.length);
          const dark = avg(blocks.slice(0, take)), bright = avg(blocks.slice(-take));
          const lb = toOklab(bright), ld = toOklab(dark), hueShift = Math.hypot(lb[1] - ld[1], lb[2] - ld[2]);
          resolve({
            face, bright, dark, grain, hueShift,
            // Conservative mapping with hard caps: photos have to show the effect clearly before the chip shows it.
            flake: clamp((grain - 1.2) / 7) * .4,
            pearl: clamp((hueShift - .012) / .05) * .35
          });
        } catch (error) { reject(error); }
      };
      image.onerror = () => reject(new Error('swatch failed to load'));
      image.src = src;
    });
  }

  function buildMesh(segments, rings, tabSegments) {
    const points = [], triangles = [], normals = [];
    const add = (p, normal) => { points.push(p); normals.push(normal || [0, 0, 0]); return points.length - 1; };
    const face = (a, b, c) => triangles.push([a, b, c]);
    const halfWidth = u => .71 * Math.sqrt(Math.max(0, 1 - u * u)) * (1 - .27 * Math.exp(-Math.pow((u - .04) / .26, 2)) + .2 * Math.exp(-Math.pow((u - .65) / .25, 2)));
    const elevation = (u, v) => {
      const edge = Math.max(0, 1 - v * v), length = Math.max(0, 1 - u * u);
      const front = .24 * Math.exp(-Math.pow((u + .47) / .4, 2));
      const rear = .27 * Math.exp(-Math.pow((u - .6) / .32, 2));
      const crown = (.23 + front + rear) * Math.pow(edge, .7) * Math.pow(length, .4);
      const path = .42 + .18 * Math.sin((u - .04) * 2.8);
      const gate = Math.exp(-Math.pow((u - .35) / .61, 4));
      const channel = .078 * Math.exp(-Math.pow((Math.abs(v) - path) / .14, 2)) * gate * edge;
      const shoulder = .045 * Math.exp(-Math.pow((Math.abs(v) - path - .18) / .19, 2)) * gate * edge;
      return .05 + crown - channel + shoulder;
    };
    const sample = (r, theta) => {
      const u = r * Math.cos(theta);
      const v = Math.sqrt(Math.max(0, (r * r - u * u) / Math.max(.00001, 1 - u * u))) * Math.sign(Math.sin(theta));
      return [1.6 * u, halfWidth(u) * v, elevation(u, v)];
    };
    const starts = [];
    const center = add(sample(0, 0));
    for (let ring = 1; ring <= rings; ring++) {
      starts[ring] = points.length;
      for (let j = 0; j <= segments; j++) add(sample(Math.sin(ring / rings * Math.PI / 2), j * 2 * Math.PI / segments));
    }
    for (let j = 0; j < segments; j++) face(center, starts[1] + j, starts[1] + j + 1);
    for (let ring = 1; ring < rings; ring++) for (let j = 0; j < segments; j++) {
      const a = starts[ring] + j, b = starts[ring + 1] + j;
      face(a, b, b + 1); face(a, b + 1, a + 1);
    }
    for (const [a, b, c] of triangles) {
      const ab = points[b].map((x, i) => x - points[a][i]), ac = points[c].map((x, i) => x - points[a][i]);
      const n = [ab[1] * ac[2] - ab[2] * ac[1], ab[2] * ac[0] - ab[0] * ac[2], ab[0] * ac[1] - ab[1] * ac[0]];
      for (const k of [a, b, c]) for (let axis = 0; axis < 3; axis++) normals[k][axis] += n[axis];
    }
    const heightAt = (x, y) => {
      const u = clamp(x / 1.6, -.99999, .99999);
      return elevation(u, clamp(y / halfWidth(u), -.99999, .99999));
    };
    for (let i = 0; i < normals.length; i++) {
      const [x, y] = points[i], u = x / 1.6, v = y / Math.max(.00001, halfWidth(u));
      normals[i] = Math.abs(u) < .99 && Math.abs(v) < .985
        ? unit([-(heightAt(x + .001, y) - heightAt(x - .001, y)) / .002, -(heightAt(x, y + .001) - heightAt(x, y - .001)) / .002, 1])
        : unit(normals[i]);
    }
    for (let ring = 1; ring <= rings; ring++) {
      const first = starts[ring], last = first + segments;
      const n = unit(normals[first].map((x, i) => x + normals[last][i]));
      normals[first] = n; normals[last] = n;
    }
    const frontCount = points.length, frontFaces = triangles.slice();
    for (let i = 0; i < frontCount; i++) add([points[i][0], points[i][1], points[i][2] - .045], normals[i].map(x => -x));
    for (const [a, b, c] of frontFaces) face(c + frontCount, b + frontCount, a + frontCount);
    const outlineNormal = angle => {
      const a = sample(1, angle - .001), b = sample(1, angle + .001);
      return unit([b[1] - a[1], a[0] - b[0], 0]);
    };
    const rim = [];
    for (let j = 0; j <= segments; j++) {
      const angle = j * 2 * Math.PI / segments, p = sample(1, angle), n = outlineNormal(angle);
      rim.push([
        add(p, unit([n[0] * .5, n[1] * .5, 1])),
        add([p[0] * 1.035, p[1] * 1.035, .025], unit([n[0] * .5, n[1] * .5, 1])),
        add([p[0] * 1.035, p[1] * 1.035, .025], n),
        add([p[0] * 1.035, p[1] * 1.035, -.032], n),
        add([p[0] * 1.035, p[1] * 1.035, -.032], unit([n[0] * .5, n[1] * .5, -1])),
        add([p[0], p[1], p[2] - .045], unit([n[0] * .5, n[1] * .5, -1]))
      ]);
    }
    for (let j = 0; j < segments; j++) {
      const a = rim[j], b = rim[j + 1];
      face(a[0], a[1], b[1]); face(a[0], b[1], b[0]);
      face(a[2], a[3], b[3]); face(a[2], b[3], b[2]);
      face(a[4], a[5], b[5]); face(a[4], b[5], b[4]);
    }
    const tab = [];
    for (let j = 0; j <= tabSegments; j++) {
      const t = j * Math.PI * 2 / tabSegments, c = Math.cos(t), s = Math.sin(t), n = unit([c / .3, s / .18, 0]);
      tab.push([
        add([-1.78 + .284 * c, .164 * s, .034], [0, 0, 1]),
        add([-1.93 + .078 * c, .078 * s, .034], [0, 0, 1]),
        add([-1.78 + .284 * c, .164 * s, .034], unit([n[0], n[1], 1])),
        add([-1.78 + .3 * c, .18 * s, .012], unit([n[0], n[1], .25])),
        add([-1.78 + .3 * c, .18 * s, -.033], n),
        add([-1.78 + .3 * c, .18 * s, -.033], [0, 0, -1]),
        add([-1.93 + .068 * c, .068 * s, -.033], [0, 0, -1]),
        add([-1.93 + .068 * c, .068 * s, -.033], [-c, -s, 0]),
        add([-1.93 + .068 * c, .068 * s, .015], unit([-c, -s, .2])),
        add([-1.93 + .078 * c, .078 * s, .034], unit([-c, -s, 1]))
      ]);
    }
    for (let j = 0; j < tabSegments; j++) {
      const a = tab[j], b = tab[j + 1];
      face(a[0], b[0], b[1]); face(a[0], b[1], a[1]);
      face(a[2], a[3], b[3]); face(a[2], b[3], b[2]);
      face(a[3], a[4], b[4]); face(a[3], b[4], b[3]);
      face(a[5], a[6], b[6]); face(a[5], b[6], b[5]);
      face(a[7], b[8], b[7]); face(a[7], a[8], b[8]);
      face(a[8], a[9], b[9]); face(a[8], b[9], b[8]);
    }
    // Pack into typed arrays: no per-frame allocation, cache friendly.
    const count = points.length, positions = new Float32Array(count * 3), packed = new Float32Array(count * 3), indices = new Uint32Array(triangles.length * 3);
    for (let i = 0; i < count; i++) for (let k = 0; k < 3; k++) { positions[i * 3 + k] = points[i][k]; packed[i * 3 + k] = normals[i][k]; }
    for (let i = 0; i < triangles.length; i++) { indices[i * 3] = triangles[i][0]; indices[i * 3 + 1] = triangles[i][1]; indices[i * 3 + 2] = triangles[i][2]; }
    return {positions, normals: packed, indices, count};
  }
  const meshes = {};
  const getMesh = level => meshes[level] ||= level === 'full' ? buildMesh(256, 64, 192) : level === 'fast' ? buildMesh(120, 30, 80) : buildMesh(48, 12, 28);

  const multiply = (a, b) => unit([
    a[3] * b[0] + a[0] * b[3] + a[1] * b[2] - a[2] * b[1],
    a[3] * b[1] - a[0] * b[2] + a[1] * b[3] + a[2] * b[0],
    a[3] * b[2] + a[0] * b[1] - a[1] * b[0] + a[2] * b[3],
    a[3] * b[3] - a[0] * b[0] - a[1] * b[1] - a[2] * b[2]
  ]);
  const axisAngle = (axis, angle) => [...axis.map(x => x * Math.sin(angle / 2)), Math.cos(angle / 2)];
  const initialView = () => multiply(axisAngle([0, 0, 1], .57), multiply(axisAngle([1, 0, 0], .33), axisAngle([0, 1, 0], -.14)));

  // Studio lighting. key = main softbox, fill = soft bounce. Shadows are cast along key.
  const LIGHTS = {
    daylight: {key: unit([-.55, .72, 1]), fill: unit([.7, -.35, .75]), shadow: .34},
    shop: {key: unit([.65, .2, .85]), fill: unit([-.7, -.1, .75]), shadow: .3}
  };
  const AMBIENT = .3, KEY = .6, FILL = .14, SHADOW_RGB = color('#111921');
  // Effect flakes per chip unit: about 2 screen pixels each at 100% zoom, so sparkle survives anti-aliasing.
  const FLAKE_CELLS = 140;
  const environments = new Map(), environmentSize = 384;
  function environment(mode) {
    if (environments.has(mode)) return environments.get(mode);
    const map = new Float32Array(environmentSize * environmentSize), shift = mode === 'daylight' ? -.33 : .42;
    for (let y = 0; y < environmentSize; y++) for (let x = 0; x < environmentSize; x++) {
      const rx = x / (environmentSize - 1) * 2 - 1, ry = y / (environmentSize - 1) * 2 - 1;
      const bx = (rx - shift) / .19, by = (ry - .46) / .75, sx = (rx + shift * 1.7) / .07, sy = (ry + .15) / .9;
      map[y * environmentSize + x] = .67 * Math.exp(-(bx ** 4) - by ** 6) + .42 * Math.exp(-(sx ** 2) - sy ** 6);
    }
    environments.set(mode, map); return map;
  }

  // Separable 3-pass box blur (~Gaussian), in place. Works identically in every browser (no ctx.filter).
  function blur(data, temp, w, h, sigma) {
    const r = Math.max(0, Math.round((Math.sqrt(4 * sigma * sigma + 1) - 1) / 2));
    if (!r) return;
    const span = 2 * r + 1;
    for (let pass = 0; pass < 3; pass++) {
      for (let y = 0; y < h; y++) {
        const row = y * w; let sum = 0;
        for (let x = -r; x <= r; x++) sum += data[row + clamp(x, 0, w - 1)];
        for (let x = 0; x < w; x++) { temp[row + x] = sum / span; sum += data[row + Math.min(w - 1, x + r + 1)] - data[row + Math.max(0, x - r)]; }
      }
      for (let x = 0; x < w; x++) {
        let sum = 0;
        for (let y = -r; y <= r; y++) sum += temp[clamp(y, 0, h - 1) * w + x];
        for (let y = 0; y < h; y++) { data[y * w + x] = sum / span; sum += temp[Math.min(h - 1, y + r + 1) * w + x] - temp[Math.max(0, y - r) * w + x]; }
      }
    }
  }
  // Coverage rasterizer for shadow masks (no culling: every face of the caster counts).
  function fillTriangles(mask, w, h, xy, indices) {
    for (let t = 0; t < indices.length; t += 3) {
      const a = indices[t] * 2, b = indices[t + 1] * 2, c = indices[t + 2] * 2;
      const ax = xy[a], ay = xy[a + 1], bx = xy[b], by = xy[b + 1], cx = xy[c], cy = xy[c + 1];
      const den = (by - cy) * (ax - cx) + (cx - bx) * (ay - cy);
      if (Math.abs(den) < 1e-6) continue;
      const minX = Math.max(0, Math.floor(Math.min(ax, bx, cx))), maxX = Math.min(w - 1, Math.ceil(Math.max(ax, bx, cx)));
      const minY = Math.max(0, Math.floor(Math.min(ay, by, cy))), maxY = Math.min(h - 1, Math.ceil(Math.max(ay, by, cy)));
      for (let y = minY; y <= maxY; y++) for (let x = minX; x <= maxX; x++) {
        const px = x + .5, py = y + .5;
        const w0 = ((by - cy) * (px - cx) + (cx - bx) * (py - cy)) / den, w1 = ((cy - ay) * (px - cx) + (ax - cx) * (py - cy)) / den;
        if (w0 >= 0 && w1 >= 0 && w0 + w1 <= 1) mask[y * w + x] = 1;
      }
    }
  }

  function setup(chip) {
    if (chip.dataset.ready) return;
    chip.dataset.ready = 'true';
    // CPU-backed canvas: every frame is written with putImageData, and a CPU canvas can't lose its pixels to GPU
    // context loss or background-tab canvas hibernation (both leave an opaque canvas black).
    const canvas = chip.querySelector('canvas'), ctx = canvas.getContext('2d', {alpha: false, willReadFrequently: true});
    if (!ctx) return;
    // Paint the stage colour immediately so the canvas is never an empty black box before the first frame.
    const blank = () => { ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, canvas.width, canvas.height); };
    blank();
    const zoomLevel = chip.querySelector('[data-chip-zoom-level]');
    // A hand-verified profile (data-flake / data-pearl) pins the finish exactly.
    const fixedFlake = chip.dataset.flake === '' || chip.dataset.flake == null ? null : clamp(Number(chip.dataset.flake) || 0);
    const fixedPearl = chip.dataset.pearl === '' || chip.dataset.pearl == null ? null : clamp(Number(chip.dataset.pearl) || 0);
    const gloss = clamp(Number(chip.dataset.gloss) || .9);
    // Classified finish for this paint (metallic / pearl strength from the colour table); the photo can only raise it.
    const hintFlake = clamp(Number(chip.dataset.finishFlake) || 0), hintPearl = clamp(Number(chip.dataset.finishPearl) || 0);
    let flake = fixedFlake ?? hintFlake, pearlAmount = fixedPearl ?? hintPearl;
    let base = color(chip.dataset.base), tones = finishPalette(base, null);
    let orientation = initialView(), zoom = 1, pan = [0, 0], lightMode = 'daylight', dragging = false, scheduled = false, visible = false, settleAt = 0, settleTimer = 0;
    const pointers = new Map();
    // Reusable buffers (reallocated only when the size changes).
    const buffers = {};
    const buffer = (name, Type, size) => (buffers[name]?.length === size ? buffers[name] : (buffers[name] = new Type(size)));
    let output = null;
    const preview = {canvas: document.createElement('canvas')};
    preview.context = preview.canvas.getContext('2d');

    function drawShadow(W, H, matrix, scale, cx, cy, light) {
      // Shadow masks are built at quarter resolution then blurred and upsampled bilinearly.
      const q = 4, w = Math.ceil(W / q) + 2, h = Math.ceil(H / q) + 2;
      const caster = getMesh('shadow'), P = caster.positions, n = caster.count;
      const rotated = buffer('shadowRot', Float32Array, n * 3), xy = buffer('shadowXY', Float32Array, n * 2);
      let minZ = Infinity;
      for (let i = 0; i < n; i++) {
        const x = P[i * 3], y = P[i * 3 + 1], z = P[i * 3 + 2];
        const rz = matrix[6] * x + matrix[7] * y + matrix[8] * z;
        rotated[i * 3] = matrix[0] * x + matrix[1] * y + matrix[2] * z; rotated[i * 3 + 1] = matrix[3] * x + matrix[4] * y + matrix[5] * z; rotated[i * 3 + 2] = rz;
        if (rz < minZ) minZ = rz;
      }
      // The chip rests just above a backdrop that faces the camera, so the shadow always sits right behind it.
      const plane = minZ - .16, perspective = 5 / (5 - plane);
      const project = (dirX, dirY, dirZ, mask) => {
        for (let i = 0; i < n; i++) {
          const k = (rotated[i * 3 + 2] - plane) / dirZ;
          xy[i * 2] = (cx + (rotated[i * 3] - dirX * k) * scale * perspective) / q + 1;
          xy[i * 2 + 1] = (cy - (rotated[i * 3 + 1] - dirY * k) * scale * perspective) / q + 1;
        }
        mask.fill(0); fillTriangles(mask, w, h, xy, caster.indices);
      };
      const s = scale * perspective / q;
      const contact = buffer('contact', Float32Array, w * h), cast = buffer('cast', Float32Array, w * h), temp = buffer('shadowTemp', Float32Array, w * h);
      project(0, 0, 1, contact); blur(contact, temp, w, h, .035 * s);
      // Large overhead softbox: shadow falls away from the key light but stays tucked under the chip.
      project(light.key[0] * .62, light.key[1] * .62, light.key[2], cast); blur(cast, temp, w, h, .1 * s);
      const alpha = buffer('shadowAlpha', Float32Array, w * h);
      for (let i = 0; i < w * h; i++) alpha[i] = 1 - (1 - .36 * contact[i]) * (1 - light.shadow * cast[i]);
      return {alpha, w, h, q};
    }

    function draw(mesh, W, H, ss, light, env) {
      const w = W * ss, h = H * ss, size = w * h;
      const colorBuffer = buffer('color', Uint8ClampedArray, size * 3), depth = buffer('depth', Float32Array, size);
      depth.fill(-1e9);
      const [qx, qy, qz, qw] = orientation;
      const m = [1 - 2 * (qy * qy + qz * qz), 2 * (qx * qy - qz * qw), 2 * (qx * qz + qy * qw), 2 * (qx * qy + qz * qw), 1 - 2 * (qx * qx + qz * qz), 2 * (qy * qz - qx * qw), 2 * (qx * qz - qy * qw), 2 * (qy * qz + qx * qw), 1 - 2 * (qx * qx + qy * qy)];
      const scale = Math.min(w / 4.1, h / 3.25) * zoom, cx = w * (.53 + pan[0]), cy = h * (.54 + pan[1]);
      const [lx, ly, lz] = light.key, [fx, fy, fz] = light.fill;
      // Half vectors between each light and the viewer drive the metallic lobe, pearl glow and flake glints.
      const [hx, hy, hz] = unit([lx, ly, lz + 1]), [gx, gy, gz] = unit([fx, fy, fz + 1]);
      // Normalise so a surface facing the viewer shows exactly the swatch colour.
      const norm = 1 / (AMBIENT + KEY * Math.max(0, lz) + FILL * Math.max(0, fz));
      const {metalHigh, metalFlop, metalSpark, pearlSheen, pearlFlop, pearlSpark} = tones;
      const P = mesh.positions, N = mesh.normals, count = mesh.count, STRIDE = 14;
      const attr = buffer('attr' + count, Float32Array, count * STRIDE);
      for (let i = 0, o = 0; i < count; i++, o += STRIDE) {
        const px = P[i * 3], py = P[i * 3 + 1], pz = P[i * 3 + 2], nx0 = N[i * 3], ny0 = N[i * 3 + 1], nz0 = N[i * 3 + 2];
        const x = m[0] * px + m[1] * py + m[2] * pz, y = m[3] * px + m[4] * py + m[5] * pz, z = m[6] * px + m[7] * py + m[8] * pz;
        const nx = m[0] * nx0 + m[1] * ny0 + m[2] * nz0, ny = m[3] * nx0 + m[4] * ny0 + m[5] * nz0, nz = m[6] * nx0 + m[7] * ny0 + m[8] * nz0;
        let ex = -x / 5, ey = -y / 5, ez = 1 - z / 5; const el = 1 / Math.sqrt(ex * ex + ey * ey + ez * ez); ex *= el; ey *= el; ez *= el;
        const facing = Math.max(0, nx * ex + ny * ey + nz * ez), grazing = 1 - facing;
        const lit = Math.min(1.35, (AMBIENT + KEY * Math.max(0, nx * lx + ny * ly + nz * lz) + FILL * Math.max(0, nx * fx + ny * fy + nz * fz)) * norm);
        const nh = Math.max(0, nx * hx + ny * hy + nz * hz), ng = Math.max(0, nx * gx + ny * gy + nz * gz);
        let c = base, glow = [0, 0, 0];
        if (flake > 0) {
          // Metallic travel: aluminium flake lies flat, so the colour darkens toward the flop and blooms near the highlight.
          c = mix(c, metalFlop, flake * Math.pow(grazing, 1.5) * .55);
          const lobe = flake * (Math.pow(nh, 14) * .3 + Math.pow(ng, 14) * .06);
          glow = [metalHigh[0] * lobe, metalHigh[1] * lobe, metalHigh[2] * lobe];
        }
        if (pearlAmount > 0) {
          // Pearl / mica interference: hue shifts toward the flop colour at angle and toward the sheen colour near the highlight.
          c = mix(c, pearlFlop, pearlAmount * Math.pow(grazing, 1.25) * .55);
          const sheen = pearlAmount * (Math.pow(nh, 6) * .25 + Math.pow(ng, 6) * .05);
          glow = [glow[0] + pearlSheen[0] * sheen, glow[1] + pearlSheen[1] * sheen, glow[2] + pearlSheen[2] * sheen];
        }
        const perspective = 5 / (5 - z);
        attr[o] = cx + x * scale * perspective; attr[o + 1] = cy - y * scale * perspective; attr[o + 2] = z;
        attr[o + 3] = c[0] * lit + glow[0]; attr[o + 4] = c[1] * lit + glow[1]; attr[o + 5] = c[2] * lit + glow[2];
        attr[o + 6] = px; attr[o + 7] = py;
        attr[o + 8] = 2 * facing * nx - ex; attr[o + 9] = 2 * facing * ny - ey; attr[o + 10] = facing;
        attr[o + 11] = nx; attr[o + 12] = ny; attr[o + 13] = nz;
      }
      // Flake glints: metallic flake is bright and near-white; pearl mica is softer and tinted by the interference colour.
      const sparkleAmount = flake + pearlAmount * .35;
      const sparkle = sparkleAmount > 0 ? mix(metalSpark, pearlSpark, pearlAmount / Math.max(.001, flake + pearlAmount)) : [0, 0, 0];
      const I = mesh.indices, E = environmentSize, EM = E - 1.001;
      for (let t = 0; t < I.length; t += 3) {
        const a = I[t] * STRIDE, b = I[t + 1] * STRIDE, c = I[t + 2] * STRIDE;
        const ax = attr[a], ay = attr[a + 1], bx = attr[b], by = attr[b + 1], cx2 = attr[c], cy2 = attr[c + 1];
        const den = (by - cy2) * (ax - cx2) + (cx2 - bx) * (ay - cy2);
        if (den >= -.00001) continue;
        const minX = Math.max(0, Math.floor(Math.min(ax, bx, cx2))), maxX = Math.min(w - 1, Math.ceil(Math.max(ax, bx, cx2)));
        const minY = Math.max(0, Math.floor(Math.min(ay, by, cy2))), maxY = Math.min(h - 1, Math.ceil(Math.max(ay, by, cy2)));
        if (minX > maxX || minY > maxY) continue;
        const dx0 = (by - cy2) / den, dx1 = (cy2 - ay) / den;
        const az = attr[a + 2], bz = attr[b + 2], cz = attr[c + 2];
        for (let y = minY; y <= maxY; y++) {
          let w0 = ((by - cy2) * (minX + .5 - cx2) + (cx2 - bx) * (y + .5 - cy2)) / den;
          let w1 = ((cy2 - ay) * (minX + .5 - cx2) + (ax - cx2) * (y + .5 - cy2)) / den;
          for (let x = minX; x <= maxX; x++, w0 += dx0, w1 += dx1) {
            const w2 = 1 - w0 - w1;
            if (w0 < -.00001 || w1 < -.00001 || w2 < -.00001) continue;
            const index = y * w + x, z = w0 * az + w1 * bz + w2 * cz;
            if (z <= depth[index]) continue;
            depth[index] = z;
            // Clear coat: environment reflection with Fresnel falloff.
            const rx = w0 * attr[a + 8] + w1 * attr[b + 8] + w2 * attr[c + 8], ry = w0 * attr[a + 9] + w1 * attr[b + 9] + w2 * attr[c + 9];
            const ex = clamp((rx + 1) * .5 * (E - 1), 0, EM), ey = clamp((ry + 1) * .5 * (E - 1), 0, EM);
            const ix = ex | 0, iy = ey | 0, tx = ex - ix, ty = ey - iy, ei = iy * E + ix;
            const reflection = (env[ei] * (1 - tx) + env[ei + 1] * tx) * (1 - ty) + (env[ei + E] * (1 - tx) + env[ei + E + 1] * tx) * ty;
            const facing = w0 * attr[a + 10] + w1 * attr[b + 10] + w2 * attr[c + 10], rim = 1 - facing, fresnel = rim * rim * rim * rim * rim;
            const sheen = gloss * (reflection * (.82 + .18 * fresnel) + .06 * fresnel);
            let r = w0 * attr[a + 3] + w1 * attr[b + 3] + w2 * attr[c + 3], g = w0 * attr[a + 4] + w1 * attr[b + 4] + w2 * attr[c + 4], bl = w0 * attr[a + 5] + w1 * attr[b + 5] + w2 * attr[c + 5];
            if (sparkleAmount > 0) {
              // Each flake cell in chip space gets its own tilt; it glints when its tilted normal lines up with a light's half vector.
              const u = w0 * attr[a + 6] + w1 * attr[b + 6] + w2 * attr[c + 6], v = w0 * attr[a + 7] + w1 * attr[b + 7] + w2 * attr[c + 7];
              let hash = (Math.floor((u + 3) * FLAKE_CELLS) * 73856093) ^ (Math.floor((v + 2) * FLAKE_CELLS) * 19349663);
              hash = Math.imul(hash ^ (hash >>> 16), 2246822519); hash ^= hash >>> 13; hash = Math.imul(hash, 3266489917); hash ^= hash >>> 16;
              const g1 = (hash & 1023) / 1023, g2 = ((hash >>> 10) & 1023) / 1023, g3 = ((hash >>> 20) & 1023) / 1023;
              // Grain: fine brightness texture that keeps metallic paint from looking like flat solid colour.
              const jitter = 1 + flake * (g3 - .5) * .16 + pearlAmount * (g3 - .5) * .05;
              r *= jitter; g *= jitter; bl *= jitter;
              const nx = w0 * attr[a + 11] + w1 * attr[b + 11] + w2 * attr[c + 11] + (g1 - .5) * .4;
              const ny = w0 * attr[a + 12] + w1 * attr[b + 12] + w2 * attr[c + 12] + (g2 - .5) * .4;
              const nz = w0 * attr[a + 13] + w1 * attr[b + 13] + w2 * attr[c + 13];
              const nl = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
              const dk = (nx * hx + ny * hy + nz * hz) * nl, df = (nx * gx + ny * gy + nz * gz) * nl;
              let spark = 0;
              if (dk > .968) { const k = (dk - .968) / .032; spark += k * k; }
              if (df > .98) { const k = (df - .98) / .02; spark += .25 * k * k; }
              if (spark > 0 && g3 > .5) {
                const s = spark * sparkleAmount * 1.1 * facing;
                r += sparkle[0] * s; g += sparkle[1] * s; bl += sparkle[2] * s;
              }
            }
            const o = index * 3;
            colorBuffer[o] = toByte(shoulder(r + sheen)); colorBuffer[o + 1] = toByte(shoulder(g + sheen)); colorBuffer[o + 2] = toByte(shoulder(bl + sheen));
          }
        }
      }
      return {w, h, colorBuffer, depth, matrix: m, scale: scale / ss, cx: cx / ss, cy: cy / ss};
    }

    // Composite: shadowed backdrop + anti-aliased chip (ss x ss box filter), resolved in linear light.
    function resolve(image, frame, shadow, W, H, ss) {
      const out = image.data, {w, colorBuffer, depth} = frame, {alpha, w: sw, q} = shadow;
      const [sr, sg, sb] = SHADOW_RGB, inv = 1 / (ss * ss);
      for (let Y = 0; Y < H; Y++) {
        const syf = (Y + .5) / q + .5, sy0 = syf | 0, fy = syf - sy0;
        for (let X = 0; X < W; X++) {
          const sxf = (X + .5) / q + .5, sx0 = sxf | 0, fx = sxf - sx0, si = sy0 * sw + sx0;
          const k = (alpha[si] * (1 - fx) + alpha[si + 1] * fx) * (1 - fy) + (alpha[si + sw] * (1 - fx) + alpha[si + sw + 1] * fx) * fy;
          let r = 0, g = 0, b = 0, background = 0;
          for (let yy = Y * ss, y1 = yy + ss; yy < y1; yy++) for (let i = yy * w + X * ss, i1 = i + ss; i < i1; i++) {
            if (depth[i] > -1e8) { const o = i * 3; r += decode[colorBuffer[o]]; g += decode[colorBuffer[o + 1]]; b += decode[colorBuffer[o + 2]]; } else background++;
          }
          r += background * (1 - k + sr * k); g += background * (1 - k + sg * k); b += background * (1 - k + sb * k);
          const o = (Y * W + X) * 4;
          out[o] = toByte(r * inv); out[o + 1] = toByte(g * inv); out[o + 2] = toByte(b * inv); out[o + 3] = 255;
        }
      }
    }

    let failures = 0, safeMode = false;
    // Hold the first frame until the chip photo has been read (at most 1.2 s), so the chip never flashes a stale colour.
    let photoReady = !chip.dataset.swatchSrc;
    const photoSettled = () => { if (photoReady) return; photoReady = true; if (inView()) { visible = true; show(); } };
    const photoTimer = setTimeout(photoSettled, 1200);
    function render() {
      scheduled = false;
      if (!visible || !chip.isConnected || !photoReady) return;
      // Not laid out yet (hidden or zero size): the ResizeObserver queues a frame once it has a size.
      if (!canvas.clientWidth || !canvas.clientHeight) return;
      try {
        renderFrame();
        failures = 0;
      } catch (error) {
        // Never leave the stage blank after a failed frame: retry with the light mesh and no supersampling.
        failures += 1; safeMode = true;
        console.warn('ACO paint chip: frame failed, retrying', error);
        if (failures < 4) setTimeout(queue, 120 * failures);
      }
    }
    function renderFrame() {
      const interacting = dragging || performance.now() < settleAt;
      const cssWidth = canvas.clientWidth, cssHeight = canvas.clientHeight;
      const W = Math.min(1600, Math.round(cssWidth * Math.min(window.devicePixelRatio || 1, 2)));
      const H = Math.max(1, Math.min(1600, Math.round(W * cssHeight / cssWidth)));
      if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      const light = LIGHTS[lightMode], env = environment(lightMode);
      // Preview while the shopper is dragging/zooming: reduced resolution and mesh, upscaled by the browser.
      // Final frame: full mesh with up to 3x3 supersampling inside a fixed sample budget.
      const previewScale = preview.context ? Math.min(1, 760 / W) : 1;
      const TW = interacting ? Math.max(1, Math.round(W * previewScale)) : W, TH = interacting ? Math.max(1, Math.round(H * previewScale)) : H;
      const ss = interacting || safeMode ? 1 : clamp(Math.floor(Math.sqrt(4.8e6 / (W * H))), 1, 3);
      const image = interacting ? (preview.image?.width === TW && preview.image.height === TH ? preview.image : (preview.image = ctx.createImageData(TW, TH))) : (output?.width === W && output.height === H ? output : (output = ctx.createImageData(W, H)));
      const frame = draw(getMesh(interacting || safeMode ? 'fast' : 'full'), TW, TH, ss, light, env);
      const shadow = drawShadow(TW, TH, frame.matrix, frame.scale, frame.cx, frame.cy, light);
      resolve(image, frame, shadow, TW, TH, ss);
      if (interacting && (TW !== W || TH !== H) && preview.context) {
        if (preview.canvas.width !== TW || preview.canvas.height !== TH) { preview.canvas.width = TW; preview.canvas.height = TH; }
        preview.context.putImageData(image, 0, 0);
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high'; ctx.drawImage(preview.canvas, 0, 0, W, H);
      } else ctx.putImageData(image, 0, 0);
      chip.dataset.rendered = interacting ? 'preview' : 'true';
    }
    const queue = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(render); } };
    // Mark continuous input; a full-quality frame follows once input settles.
    const interact = () => { settleAt = performance.now() + 140; clearTimeout(settleTimer); settleTimer = setTimeout(queue, 170); queue(); };
    const showZoom = () => { zoomLevel.textContent = `${Math.round(zoom * 100)}%`; };
    const changeZoom = value => { zoom = clamp(value, .5, 3.2); showZoom(); interact(); };
    const reset = () => { orientation = initialView(); zoom = 1; pan = [0, 0]; showZoom(); queue(); };
    const sphere = point => {
      const rect = canvas.getBoundingClientRect(), radius = Math.min(rect.width, rect.height) * .47;
      const x = (point.x - rect.left - rect.width / 2) / radius, y = (rect.top + rect.height / 2 - point.y) / radius, r2 = x * x + y * y;
      return r2 <= .5 ? [x, y, Math.sqrt(1 - r2)] : unit([x, y, .5 / Math.sqrt(r2)]);
    };
    const orbit = (from, to) => {
      const a = unit(sphere(from)), b = unit(sphere(to));
      const cross = [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
      const dot = clamp(a[0] * b[0] + a[1] * b[1] + a[2] * b[2], -1, 1);
      if (Math.hypot(...cross) > .000001) orientation = multiply(unit([...cross, 1 + dot]), orientation);
    };
    const pair = () => {
      const [a, b] = [...pointers.values()];
      return {x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, distance: Math.hypot(a.x - b.x, a.y - b.y), angle: Math.atan2(b.y - a.y, b.x - a.x)};
    };
    canvas.addEventListener('pointerdown', event => {
      if (event.button !== 0 && event.button !== 2) return;
      event.preventDefault(); canvas.focus({preventScroll: true});
      pointers.set(event.pointerId, {x: event.clientX, y: event.clientY, pan: event.button === 2}); dragging = true; canvas.setPointerCapture(event.pointerId);
    });
    canvas.addEventListener('pointermove', event => {
      const previous = pointers.get(event.pointerId); if (!previous) return;
      const before = pointers.size > 1 ? pair() : null, next = {x: event.clientX, y: event.clientY, pan: previous.pan};
      pointers.set(event.pointerId, next);
      if (before) {
        const after = pair(); zoom = clamp(zoom * after.distance / Math.max(1, before.distance), .5, 3.2); showZoom();
        orientation = multiply(axisAngle([0, 0, 1], before.angle - after.angle), orientation);
        pan[0] += (after.x - before.x) / canvas.clientWidth; pan[1] += (after.y - before.y) / canvas.clientHeight;
      } else if (event.shiftKey || previous.pan) {
        pan[0] += (next.x - previous.x) / canvas.clientWidth; pan[1] += (next.y - previous.y) / canvas.clientHeight;
      } else orbit(previous, next);
      interact();
    });
    const release = event => { if (pointers.delete(event.pointerId)) { dragging = pointers.size > 0; interact(); } };
    canvas.addEventListener('pointerup', release); canvas.addEventListener('pointercancel', release); canvas.addEventListener('lostpointercapture', release);
    canvas.addEventListener('contextmenu', event => event.preventDefault());
    canvas.addEventListener('wheel', event => { event.preventDefault(); changeZoom(zoom * Math.exp(-event.deltaY * .0015)); }, {passive: false});
    canvas.addEventListener('keydown', event => {
      const keys = {ArrowLeft: [[0, 1, 0], -.12], ArrowRight: [[0, 1, 0], .12], ArrowUp: [[1, 0, 0], -.12], ArrowDown: [[1, 0, 0], .12]};
      if (keys[event.key]) { event.preventDefault(); orientation = multiply(axisAngle(...keys[event.key]), orientation); interact(); }
      else if (event.key === '+' || event.key === '=') { event.preventDefault(); changeZoom(zoom * 1.15); }
      else if (event.key === '-') { event.preventDefault(); changeZoom(zoom / 1.15); }
      else if (event.key === 'Home') { event.preventDefault(); reset(); }
    });
    chip.querySelector('[data-chip-zoom-in]').addEventListener('click', () => changeZoom(zoom * 1.2));
    chip.querySelector('[data-chip-zoom-out]').addEventListener('click', () => changeZoom(zoom / 1.2));
    chip.querySelectorAll('[data-chip-light]').forEach(button => button.addEventListener('click', () => {
      lightMode = button.dataset.chipLight; chip.querySelectorAll('[data-chip-light]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); queue();
    }));
    chip.querySelector('[data-chip-reset]').addEventListener('click', reset);
    // Follow the product's main swatch photo; the theme value stays as the fallback colour (rendered as plain gloss).
    analyzeSwatch(chip.dataset.swatchSrc).then(photo => {
      const value = photo.face;
      base = color(value); tones = finishPalette(base, photo);
      flake = fixedFlake ?? Math.max(hintFlake, photo.flake); pearlAmount = fixedPearl ?? Math.max(hintPearl, photo.pearl);
      chip.dataset.sampledBase = value; chip.dataset.baseSource = 'swatch';
      chip.dataset.photoGrain = photo.grain.toFixed(2); chip.dataset.photoHueShift = photo.hueShift.toFixed(3);
      chip.dataset.appliedFlake = flake.toFixed(2); chip.dataset.appliedPearl = pearlAmount.toFixed(2);
      chip.querySelector('.aco-paint-chip__stage')?.style.setProperty('--aco-chip-base', value);
      if (chip.dataset.rendered) queue();
    }).catch(() => { chip.dataset.baseSource = 'theme'; }).finally(() => { clearTimeout(photoTimer); photoSettled(); });
    // Root cause of the black stage on first visits: during a busy first load the browser can hand the observer several
    // queued entries at once (e.g. "off screen" then "on screen" as the gallery images load). The old code read
    // entries[0], the oldest one, so the chip believed it was off screen and never drew its first frame. The newest
    // entry is the current state; a geometry check backs it up.
    const inView = () => {
      if (document.visibilityState === 'hidden' || !chip.isConnected) return false;
      const rect = canvas.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > -160 && rect.top < (window.innerHeight || document.documentElement.clientHeight) + 160;
    };
    const show = () => { if (chip.dataset.rendered === 'true') queue(); else interact(); };
    const observer = new IntersectionObserver(entries => {
      const wasVisible = visible;
      visible = entries[entries.length - 1].isIntersecting || inView();
      if (visible) show();
      else if (wasVisible) clearTimeout(settleTimer);
    }, {rootMargin: '160px'});
    observer.observe(canvas);
    const resize = new ResizeObserver(() => { if (!visible && inView()) visible = true; queue(); });
    resize.observe(canvas);
    // Safety net: if no full-quality frame exists shortly after load, check the geometry directly and draw.
    const ensure = () => { if (chip.dataset.rendered !== 'true' && inView()) { visible = true; show(); } };
    const timers = [400, 1500, 4000].map(delay => setTimeout(ensure, delay));
    // Redraw whenever the page comes back (tab switch, back/forward cache, restored canvas): pixels may have been dropped.
    const refresh = () => { if (inView()) { visible = true; show(); } };
    const onVisibility = () => { if (document.visibilityState === 'visible') refresh(); };
    if (document.readyState !== 'complete') window.addEventListener('load', ensure, {once: true});
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', onVisibility);
    canvas.addEventListener('contextlost', () => { chip.dataset.rendered = ''; });
    canvas.addEventListener('contextrestored', () => { blank(); refresh(); });
    chip.cleanupPaintChip = () => {
      observer.disconnect(); resize.disconnect(); clearTimeout(settleTimer); clearTimeout(photoTimer); timers.forEach(clearTimeout);
      window.removeEventListener('pageshow', refresh); document.removeEventListener('visibilitychange', onVisibility);
    };
  }
  const init = () => document.querySelectorAll('[data-aco-paint-chip]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  // Chips added after load (apps or scripts that re-render product HTML) get set up too.
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('[data-aco-paint-chip]')) setup(node);
      else if (node.firstElementChild) node.querySelectorAll('[data-aco-paint-chip]').forEach(setup);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-aco-paint-chip]').forEach(chip => chip.cleanupPaintChip?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["aco-stock-display"] && !Shopify.designMode) return;
  try {
    (() => {
  const scope = document.body;
  if (!scope || !/\/(collections|search)(\/|$)/.test(location.pathname)) return;
  const cache = new Map();
  const pending = new Map();
  const tracked = new WeakMap();
  const visible = new Set();
  const jobs = [];
  let active = 0;
  let timer;
  function drain() {
    while (active < 3 && jobs.length) {
      const job = jobs.shift();
      active++;
      job().finally(() => { active--; drain(); });
    }
  }
  function load(url) {
    const key = url.pathname;
    const saved = cache.get(key);
    if (saved && Date.now() - saved.at < 60000) return Promise.resolve(saved.value);
    if (pending.has(key)) return pending.get(key);
    const request = new Promise(resolve => {
      jobs.push(async () => {
        let value = null;
        try {
          const endpoint = new URL(key, location.origin);
          endpoint.searchParams.set('view', 'aco-stock');
          const response = await fetch(endpoint.toString(), { cache: 'no-store', signal: AbortSignal.timeout(8000) });
          if (!response.ok) throw Error('Stock unavailable');
          const payload = await response.json();
          if (payload.product?.variants && Array.isArray(payload.stock)) value = payload;
        } catch (_) {}
        cache.set(key, { value, at: Date.now() });
        pending.delete(key);
        resolve(value);
      });
    });
    pending.set(key, request);
    drain();
    return request;
  }
  function selection(card) {
    const link = card.querySelector('.spf-product-card__title a[href]');
    if (!link) return null;
    const url = new URL(link.href, location.origin);
    return url.origin === location.origin && url.pathname.includes('/products/') ? url : null;
  }
  async function refresh(card, force = false) {
    const url = selection(card);
    if (!url) return;
    const key = url.pathname + url.search;
    const previous = tracked.get(card);
    if (!force && previous?.key === key && (!previous.message || card.querySelector('[data-aco-stock]'))) return;
    const token = { key };
    tracked.set(card, token);
    card.dataset.acoStockState = 'loading';
    card.querySelector('[data-aco-stock]')?.remove();
    const payload = await load(url);
    if (!card.isConnected || tracked.get(card) !== token || selection(card)?.href !== url.href) return;
    card.dataset.acoStockState = payload ? 'checked' : 'unavailable';
    if (!payload) return;
    const id = url.searchParams.get('variant');
    const variant = id ? payload.product.variants.find(v => String(v.id) === id) : payload.product.variants.find(v => v.available);
    const entry = variant && payload.stock.find(item => String(item.id) === String(variant.id));
    token.message = entry?.message;
    if (!variant?.available || !entry?.message) return;
    const info = card.querySelector('.spf-product__info');
    if (!info) return;
    const badge = document.createElement('p');
    badge.className = 'aco-low-stock aco-low-stock--card';
    badge.dataset.acoStock = '';
    badge.textContent = (variant.title !== 'Default Title' ? variant.title + ' — ' : '') + entry.message;
    info.append(badge);
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) { visible.add(entry.target); refresh(entry.target); }
      else visible.delete(entry.target);
    }
  }, { rootMargin: '100px' });
  const observed = new WeakSet();
  function scan() {
    scope.querySelectorAll('#MainContent .spf-product-card').forEach(card => {
      if (!observed.has(card)) { observed.add(card); observer.observe(card); }
      else if (visible.has(card)) refresh(card);
    });
    for (const card of visible) if (!card.isConnected) { visible.delete(card); observer.unobserve(card); }
  }
  new MutationObserver(records => {
    if (records.every(r => r.target.closest?.('[data-aco-stock]') ||
      (r.type === 'childList' && [...r.addedNodes, ...r.removedNodes].every(n => n.nodeType === 1 && n.hasAttribute('data-aco-stock'))))) return;
    clearTimeout(timer);
    timer = setTimeout(scan, 100);
  }).observe(document.getElementById('MainContent') || scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  window.addEventListener('pageshow', event => { if (event.persisted) visible.forEach(card => refresh(card, true)); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) visible.forEach(card => refresh(card, true)); });
  scan();
})();
  } catch(e) { console.error(e); }
})();

})();
